var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.9544 31.0459 9.15527e-05 20.0002 9.15527e-05C8.95455 9.15527e-05 0.000244141 8.9544 0.000244141 20.0001C0.000244141 31.0458 8.95455 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 20C39.9999 12.0708 35.3855 5.21953 28.6956 1.98453V38.0154C35.3855 34.7805 39.9999 27.9292 39.9999 20V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 20C6.10352e-05 27.9292 4.61451 34.7805 11.3044 38.0155V1.98453C4.61451 5.21953 6.10352e-05 12.0708 6.10352e-05 20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 20C14.7825 22.8815 17.1185 25.2175 20 25.2175C22.8814 25.2175 25.2174 22.8815 25.2174 20V18.2609H14.7825V20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9564 16.5218H21.739C21.739 15.5613 20.9603 14.7826 19.9998 14.7826C19.0394 14.7826 18.2607 15.5613 18.2607 16.5218H13.0433C13.0433 17.4823 13.8799 18.2609 14.8403 18.2609H14.7824C14.7824 19.2215 15.561 20 16.5216 20C16.5216 20.9606 17.3001 21.7392 18.2607 21.7392H21.739C22.6995 21.7392 23.4781 20.9606 23.4781 20C24.4387 20 25.2173 19.2215 25.2173 18.2609H25.1593C26.1198 18.2609 26.9564 17.4823 26.9564 16.5218Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.ceefd9e92da1abc33936d131992baeb1.svg";
export { ForwardRef as ReactComponent };